/*import gliderJS from "./glider.min.js";*/
import Glide from "./glidejs.js";
import navigation from "./navigation.js";

window.addEventListener("load", function () {
    
    let header = document.getElementById('masthead');

    document.addEventListener('scroll', function() {
    
    // Get the scroll position
    let scrollPos = window.scrollY;
    
    if ( scrollPos > 131 ) {
        // Add the sticky class to the header
        /*header.classList.add("sticky-design");*/
    } else {
        header.classList.remove("sticky-design");
    }
    
    
    });
    

/*
    var sticky = {
        sticky_after: 200,
        init: function() {
            
          this.header = document.getElementById("masthead");
          //this.clone = this.header.cloneNode(true);
          //this.clone.classList.add("clone");
          //this.header.insertBefore(this.clone);
          this.scroll();
          this.events();
        },
      
        scroll: function() {
            console.log("test");
          if(window.scrollY > this.sticky_after) {
            this.header.classList.add("sticky-design");
          }
          else {
            this.header.classList.remove("sticky-design");
          }
        },
      
        events: function() {
          window.addEventListener("scroll", this.scroll.bind(this));
        }
      };
      
      document.addEventListener("DOMContentLoaded", sticky.init.bind(sticky));
*/
});


window.addEventListener("load", function () {
    if (document.getElementById("glider")) {
        var nextButton = document.querySelector("#glide-next");
        var prevButton = document.querySelector("#glide-prev");

        var glide = new Glide("#glide");

        nextButton.addEventListener("click", function (event) {
            event.preventDefault();

            glide.go(">");
        });

        prevButton.addEventListener("click", function (event) {
            event.preventDefault();

            glide.go("<");
        });

        var glide = new Glide(".glider", {
            type: "carousel",
            perView: 4,
            breakpoints: {
                900: {
                    perView: 2,
                },
                600: {
                    perView: 1,
                },
            },
        });

        glide.on("run.before", (evt) => {
            const scrollSteps = glide.settings.perView;
            evt.steps = evt.direction === ">" ? -scrollSteps : scrollSteps;
        });
        /*
glide.on("move", (evt) => {
    glide.go("=5");
});
*/
        glide.mount();
    }

    /*
    var slider = document.querySelector(".glider");
    if (slider) {
        new Glider(document.querySelector(".glider"), {
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            arrows: {
                prev: ".glider-prev",
                next: ".glider-next",
            },
            responsive: [
                {
                    // screens greater than >= 775px
                    breakpoint: 200,
                    settings: {
                        // Set to `auto` and provide item width to adjust to viewport
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        itemWidth: 280,
                        scrollLock: true,
                        duration: 0.25,
                    },
                },
                {
                    // screens greater than >= 775px
                    breakpoint: 480,
                    settings: {
                        // Set to `auto` and provide item width to adjust to viewport
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        itemWidth: 150,
                        duration: 0.25,
                    },
                },
                {
                    // screens greater than >= 775px
                    breakpoint: 768,
                    settings: {
                        // Set to `auto` and provide item width to adjust to viewport
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        itemWidth: 150,
                        duration: 0.25,
                    },
                },
            ],
        });
    }
*/

function updateMediaHeight(){
    var elements = document.getElementsByClassName("Media-wide");
    for (var i = 0; i < elements.length; i++) {
        //newHeight = elements.item(i).closest(".Media-body").clientHeight + 40;
        //console.log(elements.item(0).querySelector(".Media-body"));
        let newHeight =
            elements.item(i).querySelector(".Media-body").clientHeight + 60;

        if (elements.item(i).querySelector(".Media-bg")) {
            elements.item(i).querySelector(".Media-bg").style.height =
                newHeight + "px";
        }
    }
}
window.addEventListener("resize", updateMediaHeight);
updateMediaHeight();

const divs = document.getElementsByClassName('page_item');

for (let x = 0; x < divs.length; x++) {
    const div = divs[x];
    const content = div.textContent.trim();
    console.log(content);
  
    if (content == 'Restricted content') {
        div.style.display = 'none';
    }
}

/*
    document
        .getElementById("search-icon")
        .addEventListener("click", function () {
            var el = document.getElementById("search-form");
            if (el.style.display === "flex") {
                el.style.display = "none";
            } else {
                el.style.display = "flex";
            }
        });

document
    .getElementById("search-icon-mobile-link")
    .addEventListener("click", function () {
        var el = document.getElementById("search-form-mobile");
        if (el.style.display === "flex") {
            el.style.display = "none";
        } else {
            el.style.display = "flex";
        }
    });
    

    if (document.getElementById("sign-up")) {
        document
            .getElementById("dbtn1")
            .addEventListener("click", function (evt) {
                document.getElementById("update").style.display = "none";
                document.getElementById("sign-up").style.display = "block";
            });

        document
            .getElementById("dbtn2")
            .addEventListener("click", function (evt) {
                document.getElementById("sign-up").style.display = "none";
                document.getElementById("update").style.display = "block";
            });
        if(document.getElementById("rewards-update-link")){

            
            document
                .getElementById("rewards-update-link")
                .addEventListener("click", function (evt) {
                    evt.preventDefault();
                    document.getElementById("sign-up").style.display = "none";
                    document.getElementById("update").style.display = "block";
                });            
        }
    }

    var id = window.location.toString().split("#")[1];

    if(id == "sign-up"){
        document.getElementById('dbtn1').click();
    }else if (id == "update") {
        document.getElementById('dbtn2').click();
    }else{

    }

 


    var elements = document.getElementsByClassName("mtsnb-fixed");
    let bar_height = 0;
    for (var i = 0; i < elements.length; i++) {

       console.log(elements.item(i).clientHeight);
    //document.getElementsByName("body").style.paddingTop = elements.item(i).clientHeight + 'px';
        bar_height = elements.item(i).clientHeight;


    }       


    console.log(id);
    //deep link to west windsor on our locations page
    if(id == "west-windsor"){
        document.getElementById("wpsl-search-input").value = "West Windsor";
        setTimeout(function(){
            document.getElementById("wpsl-search-btn").click();
        }, 300);
        document.getElementById("our-locations").scrollIntoView();
    }else if(id != ""){
       
        console.log(window.location.hash);
        console.log("bar" + bar_height);

        var topOfElement = document.getElementById(id).offsetTop - bar_height;
        console.log(topOfElement);
        window.scroll({ top: topOfElement, behavior: "smooth" });
        //document.getElementById(id).scrollIntoView();
    }


    //if there is a banner
/*
    var elements = document.getElementsByClassName("mtsnb-fixed");
    for (var i = 0; i < elements.length; i++) {

       console.log(elements.item(i).clientHeight);
    document.getElementsByName("body").style.paddingTop = elements.item(i).clientHeight + 'px';
    }    
*/
    
    
});